import { PubNubService } from "../../../../../core/services/pubnub.service";
import { Component, OnInit, ViewEncapsulation, ViewChild } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import {
  Router,
  ActivatedRoute,
  RouterStateSnapshot,
  NavigationEnd,
} from "@angular/router";
import * as $ from "jquery";
import { CommanSubscribeService } from "src/app/core/services/comman-subscribe.service";
import { WalletInfo } from "src/app/core/models/wallet-info.model";
import { Subscription } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { StorageService } from "src/app/core/services/storage.service";
import { UserService } from "src/app/core/services/user.service";
import { environment } from "src/environments/environment";
import { LandingPageService } from "src/app/core/services/landing-page.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { API } from "../../../../../core/constants";
import { AppService } from "./../../../../../core/services/app.service";
import { Web3Service } from "src/app/core/services/web3.service";
import { WalletConnectDialogComponent } from "../../../wallet-connect-dialog/wallet-connect-dialog.component";
import { MatDialog } from "@angular/material/dialog";
@Component({
  selector: "app-new-layout",
  templateUrl: "./new-layout.component.html",
  styleUrls: ["./new-layout.component.scss"],
  encapsulation: ViewEncapsulation.None,
  host: {
    "(document:click)": "onClick($event)",
  },
})
export class NewLayoutComponent implements OnInit {
  @ViewChild("sidenav", { static: false })
  sidenav: MatSidenav;
  @ViewChild("rightsidenav", { static: false })
  rightsidenav: MatSidenav;

  sidetoggle = false;
  copyRightYear = new Date().getFullYear();
  userInfo: any = {};
  userInfoSubscription: Subscription;
  ticket_key: any;
  event_id: any;
  user_id: any;
  isPubNubChannelAvailable: boolean;
  openPubNubChannel: any;
  isNetworkNotification: boolean = false;
  message: any;
  inviteKey: string;
  ticketStatus: any;
  upcomingEventsInfo: any;
  upcomingEventsInfoSubscription: Subscription;
  clientDetails: any;
  assets_url = environment.assets_url;
  loggedIn: boolean = false;
  displayName = "";
  profileName = "";
  routerevents: any;
  snapshot: RouterStateSnapshot;
  subscriptionRightTabMenuActive: Subscription;
  menuNames: any = [];
  menuList: any;
  deviceType: any = "";
  deviceData: Subscription;
  userList: any;
  subscriptionRightTabUserActive: Subscription;
  userIdParam: any;
  imagedata: any;
  performerInfoSubscr: Subscription;
  pName: any = "";
  isCryptoWallet = environment.required_crypto_wallet;
  get cashWalletLink(): string { return (this.pName ? '/' + this.pName : '') + '/user-dashboard/cash-wallet'; }
  walletID: string;
  walletInfo: WalletInfo;
  network_name: String;
  nftNavigation: boolean = false;
  constructor(
    public router: Router,
    private landingPageService: LandingPageService,
    private pubnubService: PubNubService,
    private storageService: StorageService,
    private userService: UserService,
    private toastr: ToastrService,
    private commonSubscribeService: CommanSubscribeService,
    public route: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    private appService: AppService,
    private web3Service: Web3Service,
    public dialog: MatDialog
  ) {
    this.subscriptionRightTabMenuActive = this.commonSubscribeService
      .getLeftTabActiveBasedOnRouterURL()
      .subscribe((message) => {
        if (this.rightsidenav) {
          setTimeout(() => {
            this.rightSideActive();
          }, 1000);
        }
      });
    this.commonSubscribeService.walletInfoSubject.subscribe((result) => {
      if (result?.organizationId === this.commonSubscribeService.orgId) {
        this.walletInfo = result.wallet;
      }
    });
    this.routerevents = router.events.subscribe((val) => {
      this.snapshot = router.routerState.snapshot;
      if (val instanceof NavigationEnd) {
        if (
          this.route &&
          this.route.firstChild &&
          this.route.firstChild.paramMap
        ) {
          this.route.firstChild.paramMap.subscribe((params: any): void => {
            this.pName = params.params["pName"];
            this.ticket_key = params.params["ticket_key"];
            this.userInfo = this.commonSubscribeService.userInfo;
            let eventId;
            if (
              !this.storageService.getItem("ticket_key") &&
              this.ticket_key != undefined
            ) {
              this.storageService.setItem("ticket_key", this.ticket_key);
              let id = this.ticket_key;
              if (id && id.includes("-")) eventId = id.split("-");
            }
            if (eventId)
              this.event_id = eventId ? eventId[0] : params.params["id"];
            // this.connectChannel()
            // this.getLiveEvent();
            // this.getOrgInfo();
          });
        }
      }
    });
  }
  gotoCreator() {
    window.open(environment.VENDOR_PORTAL, "_blank");
  }
  gotoCommunities() {
    this.router.navigate(["/communities"]);
  }
  getAvailBalance() {
    this.walletInfo = this.commonSubscribeService.walletByOrg[this.commonSubscribeService.orgId];
    if (!this.walletInfo || Object.keys(this.walletInfo).length == 0) {
      this.commonSubscribeService.getAvailBalance((result) => {
        this.walletInfo = result;
      }, this.commonSubscribeService.orgId);
    }
  }
  connectChannel() {
    if (this.storageService.getItem("ticket_key")) {
      this.ticket_key = this.storageService.getItem("ticket_key");
      this.event_id = this.ticket_key.split("-")[0];
    }
    if (this.ticket_key) {
      this.event_id = this.ticket_key ? this.ticket_key.split("-")[0] : 0;
      this.user_id = this.ticket_key ? this.ticket_key.split("-")[1] : 0;
    }
    console.log("ticket_key :: ", this.ticket_key);
    this.pubnubService.init();
    if (this.user_id && this.event_id) this.connectPubNubChannels();
  }
  ngOnInit() {
    this.web3Service.connectedAccId.subscribe(
      (walletId) => (this.walletID = walletId)
    );
    this.network_name = "Ethereum Rinkeby";
    this.web3Service.setNetwork(this.network_name);
    // this.getAccountBalance();
    this.web3Service.connectedAccId.subscribe(
      (walletId) => (this.walletID = walletId)
    );
    this.commonSubscribeService.getAccountBalance(this.walletID);
    this.getAvailBalance();
    this.clientDetails = environment.clientDetails;
    this.deviceType = this.commonSubscribeService.deviceType;
    this.deviceData = this.commonSubscribeService
      .getAppType()
      .subscribe((response) => {
        this.deviceType = response;
      });
    this.userInfo = this.commonSubscribeService.userInfo;
    this.getName();
    this.userInfoSubscription = this.commonSubscribeService
      .getUserInfo()
      .subscribe((response) => {
        this.userInfo = response;
        this.getName();
        let userInfo = this.storageService.getItem("user_Info");
        if (
          userInfo &&
          userInfo.access_token &&
          this.userInfo &&
          this.userInfo.id
        ) {
          this.loggedIn = true;
        } else {
          this.loggedIn = false;
        }
      });
    let userInfo = this.storageService.getItem("user_Info");
    if (
      userInfo &&
      userInfo.access_token &&
      this.userInfo &&
      this.userInfo.id
    ) {
      this.loggedIn = true;
    }

    let perfomerInfoData = this.commonSubscribeService.perfomerInfoData;
    this.performerInfoSubscr = this.commonSubscribeService
      .getPerfomerInfo()
      .subscribe((response) => {
        perfomerInfoData = response;
      });
    if (perfomerInfoData && perfomerInfoData.data) {
      this.imagedata = perfomerInfoData.data.Data[0].org_info.organization_logo;
    }
    // console.log(perfomerInfoData,perfomerInfoData.data.Data[0].org_info.organization_logo,this.imagedata)
    this.userIdParam = this.route.snapshot.queryParamMap.get("user_id");

    this.menuList = [
      // {
      //   icon: "fa fa-heart menu-icon mr-10",
      //   name: "Favorites",
      //   link: "user-dashboard/favorites",
      // },
      // {
      //   icon: "fa fa-calendar menu-icon mr-10",
      //   name: "Calendar",
      //   link: "user-dashboard/calendar",
      //   sub_menu: []
      // },

      {
        icon: "fa fa-user menu-icon mr-10",
        name: "My Profile",
        // link: "user-dashboard/profile-settings/basic-info",
        sub_menu: [
          {
            menu_name: "Basic info",
            type: "basic-info",
            link: "user-dashboard/profile-settings/basic-info",
            dualapp: true,
          },
          {
            menu_name: "Change Password",
            type: "change-password",
            link: "user-dashboard/profile-settings/change-password",
            dualapp: true,
          },
        ],
      },
      {
        icon: "fa fa-calendar-check-o menu-icon",
        name: "My Events",
        flag: "true",
        sub_menu: [
          {
            menu_name: "Live",
            type: "live_events",
            link: "user-dashboard/My-events",
            dualapp: true,
          },
          {
            menu_name: "Upcoming",
            type: "upcoming_events",
            link: "user-dashboard/My-UpcomingEvents",
            dualapp: true,
          },
          {
            menu_name: "Past",
            type: "past_events",
            link: "user-dashboard/My-PastEvents",
            dualapp: true,
          },
        ],
      },
      {
        icon: "fa fa-user menu-icon mr-10",
        name: "My Payments",
        // link: "user-dashboard/profile-settings/basic-info",
        sub_menu: [
          {
            menu_name: "Payment Methods",
            type: "payment-methods",
            link: "user-dashboard/payment-methods",
            dualapp: true,
          },
          {
            menu_name: "My Address",
            type: "my-address",
            link: "user-dashboard/my-address",
            dualapp: true,
          },
          {
            menu_name: "Subscribed Channels",
            type: "subscribed-channel",
            link: "user-dashboard/subscribed-channel",
            dualapp: this.deviceType == "browser" ? true : false,
          },
          {
            menu_name: "My Purchases",
            type: "my-purchases",
            link: "user-dashboard/my-purchases",
            dualapp: true,
          },
          {
            menu_name: "Order History",
            type: "order-history",
            link: "user-dashboard/order-history",
            dualapp: true,
          },
          {
            menu_name: "Tips/Donations",
            // icon: "fa fa-handshake-o menu-icon mr-10",
            name: "Tips/Donations",
            link: "user-dashboard/tips-donations",
            dualapp: true,
          },
        ],
      },
      {
        icon: "fa fa-th-large menu-icon",
        name: "My NFT",
        link: "nft-profile",
        sub_menu: [],
        dualapp: true,
        hide: this.isCryptoWallet == 1 ? false : true,
      },
      {
        icon: "fa fa-heart menu-icon",
        name: "My Wishlist",
        link: "user-dashboard/My_WishList",
        sub_menu: [],
        dualapp: true,
      },
      {
        icon: "fa fa-info-circle menu-icon ml-10",
        name: "Crypto Instructions",
        link: "user-dashboard/crypto-instructions",
        sub_menu: [],
        dualapp: true,
        hide: environment.clientDetails.required_crypto_wallet === 0,
      },
    ];
    this.userList = [
      {
        icon: "fa fa-th-large menu-icon mr-10",
        name: "Home",
        link: `/${this.pName}`,
        activeMenuName: "live",
        sub_menu: [],
      },
      {
        icon: "fa fa-user menu-icon mr-10",
        name: "Profile",
        link: `/${this.pName}/profile`,
        sub_menu: [],
      },
      {
        icon: "fa fa-calendar menu-icon mr-10",
        name: "Upcoming",
        link: `/${this.pName}/upcoming-events`,
        sub_menu: [],
      },
      {
        icon: "fa fa-video-camera menu-icon mr-10",
        name: "Videos",
        link: `/${this.pName}/videos`,
        sub_menu: [],
      },
      {
        icon: "fa fa-file-audio-o menu-icon mr-10",
        name: "Audios",
        link: `/${this.pName}/audios`,
        sub_menu: [],
      },
      // {
      //   icon: "fa fa-users menu-icon mr-10",
      //   name: "Followers",
      //   link: `/${this.pName}/${this.pId}/followers`,
      //   sub_menu:[]
      // },
    ];
    this.goToUser(this.router.url);
    if (this.menuList) {
      this.menuList.forEach((val) => {
        if (val.menu) {
          val.menu.forEach((submenu) => {
            if (this.router.url.includes(submenu.type.toLowerCase())) {
              submenu.subMenuActive = true;
            } else {
              submenu.subMenuActive = false;
            }
          });
        }
      });
    }
    this.goToMenu(this.router.url);
    // this.getCategory();
    this.subscriptionRightTabMenuActive = this.commonSubscribeService
      .getLeftTabActiveBasedOnRouterURL()
      .subscribe((message) => {
        if (this.rightsidenav) {
          setTimeout(() => {
            this.rightSideActive();
          }, 2000);
        }
      });
    this.subscriptionRightTabUserActive = this.commonSubscribeService
      .getLeftTabActiveBasedOnRouterURL()
      .subscribe((message) => {
        setTimeout(() => {
          this.rightTabActive();
        }, 1000);
      });

    this.upcomingEventsInfo = this.commonSubscribeService.upcomingEventInfo;
    this.upcomingEventsInfoSubscription = this.commonSubscribeService
      .getUpcomingEvents()
      .subscribe((response) => {
        this.upcomingEventsInfo = response;
        // if(this.upcomingEventsInfo.length == 0)
        //   this.router.navigateByUrl('/becomeapartner');
      });
    $(window).scroll(function () {
      if ($(document).scrollTop() > 40) {
        $(".navbar").addClass("affix");
        $(".logo").removeClass("logo-bg");
        $(".gt-bg").removeClass("logo-bg");
        $(".navbar-nav").removeClass("logo-bg");
      } else {
        $(".navbar").removeClass("affix");
        $(".logo").addClass("logo-bg");
        $(".gt-bg").addClass("logo-bg");
        $(".navbar-nav").addClass("logo-bg");
      }
    });
    // if (this.event_id != 0 && this.user_id != 0 && !this.router.url.includes('network-room')) {
    //   setTimeout(() => {
    //     this.sbService.init();
    //     this.sb = this.sbService.sb;
    //     if(this.user_id && this.event_id)
    //       this.connectPubNubChannels();
    //   }, 5000);
    // }
    this.commonSubscribeService.sendTrackingCode({});
  }
  rightTabActive() {
    this.userList = this.commonSubscribeService.getFilterMenu(
      this.userList,
      this.router.url,
      "allMenu"
    );
  }

  goToUser(link, menu?) {
    // this.storageService.deleteItem('eventInfo');
    this.userList = this.commonSubscribeService.getFilterMenu(
      this.userList,
      link,
      menu
    );
    this.router.navigateByUrl(link);
    if (menu) {
      this.rightsidenav.close();
    }
    this.commonSubscribeService.setLeftTabActiveBasedOnRouterURL("");
  }
  goToMenu(link, menu?) {
    // if (Object.keys(this.userInfo)?.length != 0 && !this.userInfo.is_profile_completed &&
    //   link.indexOf("user-dashboard/profile-settings/basic-info") == -1) {
    //   this.toastr.info("Please update your profile details");
    //   this.router.navigateByUrl('/user-dashboard/profile-settings/basic-info');
    //   if (this.rightsidenav) {
    //     this.rightsidenav.close();
    //   }
    //   return;
    // }

    this.menuList = this.commonSubscribeService.getFilterMenu(
      this.menuList,
      link,
      menu
    );
    if (link) {
      this.router.navigateByUrl(link);
    } else if (menu) {
      let obj = this.menuList.filter((m) => m.name == menu.name)[0];
      this.router.navigateByUrl(obj.sub_menu[0].link);
    }
    if (menu && this.rightsidenav) {
      this.rightsidenav.close();
    }
    this.commonSubscribeService.setLeftTabActiveBasedOnRouterURL("");
  }
  navigateSubmenu(data) {
    // if (Object.keys(this.userInfo)?.length != 0 && !this.userInfo.is_profile_completed &&
    //   data.indexOf("user-dashboard/profile-settings/basic-info") == -1) {
    //   this.toastr.info("Please update your profile details");
    //   this.router.navigateByUrl('/user-dashboard/profile-settings/basic-info');
    //   if (this.rightsidenav) {
    //     this.rightsidenav.close();
    //   }
    //   return;
    // }

    this.menuList = this.commonSubscribeService.getFilterMenu(
      this.menuList,
      data,
      "subMenu"
    );
    this.rightsidenav.close();
    this.router.navigateByUrl(data);
    this.commonSubscribeService.setLeftTabActiveBasedOnRouterURL("");
  }

  async connectToWallet() {
      this.web3Service.setNetwork(environment.clientDetails.network_name);
      await this.web3Service
        .checkAndInstantiateWeb3()
        .then((isweb3) => {
          console.log("isweb3", isweb3);
          if (isweb3 === "connected") {
            this.web3Service.setContract();
            this.web3Service.connectAccount().then((res) => {
              console.log("before get account balance", res);
              this.walletID = res;
              this.commonSubscribeService.getAccountBalance(this.walletID);
              console.log("after get account balance");
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.dialog.open(WalletConnectDialogComponent, {
            panelClass: "app-consumer-sign-in",
            hasBackdrop: true,
            data: {
              text: !this.nftNavigation
                ? "Please install wallet to continue with NFT"
                : "",
            },
          });
          this.nftNavigation = false;
        });
    }

  async checkAndNavigateToNFT() {
    try {
      this.connectToWallet();
      if (this.walletID) {
        this.router.navigate(["/nft/collections"]);
      }
    } catch (error) {
      this.toastr.error("Please install a wallet to access NFT collections."); // Show error message
    }
  }

  goToRespectiveScreen(path) {
    if (path == "home") this.router.navigateByUrl("");
    else this.router.navigateByUrl(path);
  }

  opensidenav() {
    this.sidetoggle = !this.sidetoggle;
  }

  onClick(event) {
    //console.log(event);
    if (event.target.id == "") {
      // console.log(this);
      this.rightsidenav.close();
    }
  }

  rightSideActive() {
    this.menuList = this.commonSubscribeService.getFilterMenu(
      this.menuList,
      this.router.url,
      "allMenu"
    );
    this.rightsidenav.close();
  }

  getName() {
    if (this.userInfo) {
      if (this.userInfo.user_display_name) {
        let name;
        if (
          this.userInfo.user_display_name &&
          this.userInfo.user_display_name.includes(" ")
        ) {
          name = this.userInfo.user_display_name.split(" ");
          if (name[0] && !name[1] && name[1] != "") {
            this.displayName = name[0][0] + name[0][1];
          } else if (name[1][0] != undefined) {
            this.displayName = name[0][0] + (name[2] ? name[2][0] : name[1][0]);
          } else {
            this.displayName = this.userInfo.user_display_name[0];
          }
        } else if (this.userInfo.user_display_name[1] != undefined) {
          this.displayName =
            this.userInfo.user_display_name[0] +
            this.userInfo.user_display_name[1];
        } else {
          this.displayName = this.userInfo.user_display_name[0];
        }
        // this.displayName = this.userInfo.user_first_name[0] + this.userInfo.user_last_name[0];
        this.profileName = this.userInfo.user_display_name;
        // this.profileName = this.userInfo.user_first_name + " " + this.userInfo.user_last_name;
      } else if (this.userInfo.user_first_name) {
        this.displayName =
          this.userInfo.user_first_name[0] + this.userInfo.user_first_name[1];
        this.profileName = this.userInfo.user_first_name;
      } else if (this.userInfo.user_email) {
        this.displayName =
          this.userInfo.user_email[0] + this.userInfo.user_email[1];
      }
    }
  }

  signout() {
    this.storageService.deleteItem("eventInfo");
    this.storageService.deleteItem("isEvent");
    this.ngxLoader.start();
    this.appService.postRequest(API.FAN_LOGOUT, "").subscribe(
      (result) => {
        this.ngxLoader.stop();
        if (result["status"] == 0) {
          this.loggedIn = false;
           localStorage.isFanLoginUser =false;
          // this.storageService.deleteItem("userInfo");
          this.storageService.deleteItem("isAffiliateUser");
          this.storageService.deleteItem("user_Info");
          this.storageService.deleteItem("ticket_key");
          this.storageService.deleteItem("product_info");
          this.commonSubscribeService.sendTriggeredEvent({ actionType: 'sign-out', actionName: 'USER_LOGOUT', organizationId: this.commonSubscribeService.orgId || null });
          this.commonSubscribeService.sendUserInfo({});
          this.commonSubscribeService.sendMylistData([]);
          this.userInfo = {};
          this.rightsidenav.close();
          this.web3Service.signout();
         
          
        this.storageService.deleteItem("signInRouteData");
        sessionStorage.removeItem('oidcAttempted');
        this.storageService.deleteItem("redirectUrlAfterGoogleLogin");
        // Step 3: Trigger OneLogin logout (OIDC)
          const ONELOGIN_DOMAIN = `${environment.OIDC.onelogin_account_name}.onelogin.com`;//environment.onelogin_domain;
          const POST_LOGOUT_REDIRECT_URI = environment.social_auth_redirect_uri;
          // const POST_LOGOUT_REDIRECT_URI = "http://localhost:4200/";
          const ID_TOKEN = localStorage.getItem("id_token");

          if (ID_TOKEN) {
            const formattedIdToken = ID_TOKEN.replace(/^"|"$/g, ""); // remove extra quotes
            const logoutUrl =
              `https://${ONELOGIN_DOMAIN}/oidc/2/logout` +
              `?id_token_hint=${encodeURIComponent(formattedIdToken)}` +
              `&post_logout_redirect_uri=${encodeURIComponent(POST_LOGOUT_REDIRECT_URI)}`;

            window.location.href = logoutUrl; // redirect to OneLogin logout page
          } else {
            localStorage.clear();
            this.router.navigateByUrl("");
          }



        } else {
          this.ngxLoader.stop();
          this.toastr.error(result["message"]);
        }
        // this.message = result.message;
      },
      (error) => {
        this.ngxLoader.stop();
        console.log(error);
      }
    );
  }

  connectPubNubChannels() {
    this.pubnubService.connect(this.user_id.toString(), (success,error) => {
      if (error) {
        console.log("Error while connecting chat user", error);
        this.isPubNubChannelAvailable = false;
        // this.toastr.error("Error while connecting chat user");
        return;
      } else {
        this.pubnubService.enterChannel(
          this.event_id + "_notifications",
          1,
          (openChannel, error) => {
            if (error) {
              console.log("Error while connecting chat channel", error);
              this.isPubNubChannelAvailable = false;
              // this.toastr.error("Channel not available");
              return;
            }
            this.isPubNubChannelAvailable = true;
            this.openPubNubChannel = openChannel;
          }
        );
      }
    });
    
    this.pubnubService.receiveMessages(
      this.event_id + "_notifications",
      (response) => {
        let channel = response.channel;
        let message = response.message;
        if (
          channel &&
          this.openPubNubChannel &&
          channel === this.openPubNubChannel &&
          message.customType == "NETWORKING" &&
          message.data != ""
        ) {
          this.isNetworkNotification = true;
          let data = JSON.parse(message.data);
          this.message = message.message;
          this.inviteKey =
            environment.CONSUMER_PORTAL +
            `${this.router.url.split("/")[1]}/event/networking-list/` +
            this.ticket_key +
            "/" +
            data.id;
          console.log("this.isNetworkNotification", this.isNetworkNotification);
          setTimeout(() => {
            this.closeBox();
          }, 10000);
        }
      }
    );
  }
  closeBox() {
    this.isNetworkNotification = false;
  }
  copyToClipboard(type) {
    // if (this.eventInfo.publish == 1) {
    const el = document.createElement("textarea");
    el.value = this.inviteKey;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    this.isNetworkNotification = false;
    this.toastr.success("Copied..!");
    // } else {
    //   this.toastr.info('Please publish the event');
    // }
  }
  joinUrl() {
    this.isNetworkNotification = false;
    window.open(this.inviteKey, "_blank");
  }
  redirectTo(path) {
    if (path != "signin" && path != "signup")
      this.storageService.deleteItem("eventInfo");
    this.storageService.deleteItem("isEvent");
    // this.sidenav.close();
    if (path == "signin") this.landingPageService.openConsumerSignIn();
    else this.router.navigateByUrl(path);
  }
  ngOnDestroy() {
    this.pubnubService.disconnect([this.event_id + "_notifications"]);
    if (this.ticketStatus) this.ticketStatus.unsubscribe();
    if (this.userInfoSubscription) this.userInfoSubscription.unsubscribe();
    if (this.upcomingEventsInfoSubscription)
      this.upcomingEventsInfoSubscription.unsubscribe();
    if (this.performerInfoSubscr) {
      this.performerInfoSubscr.unsubscribe();
    }
    if (this.subscriptionRightTabMenuActive) {
      this.subscriptionRightTabMenuActive.unsubscribe();
    }
    if (this.subscriptionRightTabUserActive) {
      this.subscriptionRightTabUserActive.unsubscribe();
    }
  }
}
